// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtClaimSubmitClaimResultModel {
    static getAttributeTypeMap() {
        return ExtClaimSubmitClaimResultModel.attributeTypeMap;
    }
}
ExtClaimSubmitClaimResultModel.discriminator = undefined;
ExtClaimSubmitClaimResultModel.additionalProperties = false;
ExtClaimSubmitClaimResultModel.attributeTypeMap = [
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "channelId",
        "baseName": "channelId",
        "type": "string"
    },
    {
        "name": "alternatePatientId",
        "baseName": "alternatePatientId",
        "type": "string"
    },
    {
        "name": "docType",
        "baseName": "docType",
        "type": "TCSDocumentType"
    },
    {
        "name": "uploadFilesList",
        "baseName": "uploadFilesList",
        "type": "Array<ExtClaimFileOutputModel>"
    },
];
//# sourceMappingURL=extClaimSubmitClaimResultModel.js.map